<template>
  <table-layout title="محصولات" :showSearch="false">
    <template #buttons>
      <b-row>
        <router-link class="ml-2 mt-1" :to="{ name: 'TrashProduct' }">
          <b-button pill variant="danger"> سطل زباله</b-button>
        </router-link>

        <router-link :to="{ name: 'CreateProduct' }" class="ml-2 mt-1">
          <b-button pill variant="purple"> ساخت محصول</b-button>
        </router-link>

        <b-button @click="FilterProduct()" pill variant="purple" class="ml-2 mt-1">
          <span v-if="is_digital == false">نمایش محصولات دیجیتال</span>
          <span v-else>نمایش محصولات فیزیکی</span>
        </b-button>
      </b-row>

    </template>


    <template #table>
      <table-items :items="products" :restoreState="false"/>
      <b-row class="pt-3 mt-3">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </b-row>
    </template>


  </table-layout>
</template>

<script>
import {mapGetters} from "vuex";
import TableLayout from "../../components/dashboard/TableLayout.vue";
import tableItems from "../../components/dashboard/product/tableItems.vue";
import Pagination from "../../components/dashboard/Pagination.vue";


export default {
  name: "Product",
  data() {
    return {
      is_digital: false
    }
  },
  components: {TableLayout, tableItems, Pagination},
  computed: {
    ...mapGetters({
      products: "Product/getProducts",
      paginationMeta: "Product/getPaginationMeta",
    }),
    is_digital_condition() {
      return this.is_digital == false ? 0 : 1
    }
  },
  mounted() {
    this.$store.commit('Product/setFilters', {
      key: 'is_digital',
      value: this.is_digital_condition
    })
    this.$store.dispatch("Product/setDashboardProducts", 1);
  },
  methods: {
    changePage(page) {
      this.$store.commit('Product/setFilters', {
        key: 'is_digital',
        value: this.is_digital_condition
      })
      this.$store.dispatch("Product/setDashboardProducts", page);

    },
    FilterProduct() {
      this.is_digital = !this.is_digital
      this.$store.commit('Product/setFilters', {
        key: 'is_digital',
        value: this.is_digital_condition
      })
      this.$store.dispatch("Product/setDashboardProducts");
    }

  }
};
</script>